import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

import { overrideOrganizationHeader } from '@cast/api-client';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const PLATFORM_USAGE_REPORT_QUERY_KEY = 'platform-usage-report';
const getPlatformUsageReportQueryKey = (params: {
  organizationId: string | undefined;
}) => [PLATFORM_USAGE_REPORT_QUERY_KEY, params.organizationId] as const;

const getPlatformUsageReportQueryOptions = ({
  organizationId,
  enabled = true,
}: {
  organizationId: string | undefined;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getPlatformUsageReportQueryKey({ organizationId }),
    queryFn: async () => {
      const { data } = await apiClient.billing.getPlatformUsageReport({
        headers: overrideOrganizationHeader(organizationId),
      });
      return data;
    },
    enabled: makeIsEnabled(!!organizationId, enabled),
  });

export const usePlatformUsageReportQuery = () => {
  const { currentOrganization } = useOrganizations();
  const { isLoading, isError, data, error, refetch } = useQuery(
    getPlatformUsageReportQueryOptions({
      organizationId: currentOrganization?.id,
    })
  );

  return { isLoading, isError, data, error, refetch };
};
